import { typedObjectFromEntries } from '@gozoki/tools'

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const
export type WeekDay = (typeof weekDays)[number]

/** Jours rangés dans l'ordre de la semaine (lundi d'abord), sans toucher au tableau reçu. */
export const sortWeekDays = (days: readonly WeekDay[]): WeekDay[] =>
  [...days].sort((a, b) => weekDays.indexOf(a) - weekDays.indexOf(b))

/** Objet indexé par jour de la semaine, chaque valeur calculée pour son jour. */
export const mapWeekDays = <T>(valueOf: (day: WeekDay) => T): Record<WeekDay, T> =>
  typedObjectFromEntries(weekDays.map((day) => [day, valueOf(day)] as const))
